const fetchProductLevelRidersBenefit = (benefitList, biData) => {
  // ADB RIDER
  if (
    biData.bi_request?.ADBRider &&
    !benefitList.some((item) => item?.rider === "ABD")
  ) {
    benefitList.push({
      label: "Greater financial support to family in case of accidental death",
      rider: "ABD",
    });
  } else if (
    !biData.bi_request?.ADBRider &&
    benefitList.some((item) => item?.rider === "ABD")
  ) {
    benefitList = benefitList.filter((item) => item?.rider !== "ABD");
  }

  // ATPD RIDER
  if (
    biData.bi_request?.ATPDRider &&
    !benefitList.some((item) => item?.rider === "ATPD")
  ) {
    benefitList.push({
      label: "Reduces the financial stress of a disability due to accident",
      rider: "ATPD",
    });
  } else if (
    !biData.bi_request?.ATPDRider &&
    benefitList.some((item) => item?.rider === "ATPD")
  ) {
    benefitList = benefitList.filter((item) => item?.rider !== "ATPD");
  }

  // CRITICARE ILLNESS
  if (
    biData.bi_request?.CriticalIllnessRider &&
    !benefitList.some((item) => item?.rider === "CriticalIllnessRider")
  ) {
    benefitList.push({
      label: "Mitigates the financial stress of a critical illness",
      rider: "CriticalIllnessRider",
    });
  } else if (
    !biData.bi_request?.CriticalIllnessRider &&
    benefitList.some((item) => item?.rider === "CriticalIllnessRider")
  ) {
    benefitList = benefitList.filter(
      (item) => item?.rider !== "CriticalIllnessRider"
    );
  }

  // Income Benefit Rider
  if (
    biData.bi_request?.IncomeBenefitRider &&
    !benefitList.some((item) => item?.rider === "IncomeBenefitRider")
  ) {
    benefitList.push({
      label:
        "Safe, regular financial cushion to soften the shock of a loss for your family",
      rider: "IncomeBenefitRider",
    });
  } else if (
    !biData.bi_request?.IncomeBenefitRider &&
    benefitList.some((item) => item?.rider === "IncomeBenefitRider")
  ) {
    benefitList = benefitList.filter(
      (item) => item?.rider !== "IncomeBenefitRider"
    );
  }

  // Waiver of Premium Rider
  if (
    biData.bi_request?.WaiverOfPremiumRider &&
    !benefitList.some((item) => item?.rider === "WaiverOfPremiumRider")
  ) {
    benefitList.push({
      label:
        "Freedom from worries of liabilities during any future health crisis",
      rider: "WaiverOfPremiumRider",
    });
  } else if (
    !biData.bi_request?.WaiverOfPremiumRider &&
    benefitList.some((item) => item?.rider === "WaiverOfPremiumRider")
  ) {
    benefitList = benefitList.filter(
      (item) => item?.rider !== "WaiverOfPremiumRider"
    );
  }

  // Payor Waiver  Benefit Rider
  if (Number(biData.bi_request?.PayorWaiverBenefitRider) === 1) {
    if (
      (Number(biData.bi_request?.PWB) === 1 ||
        Number(biData.bi_request?.PWB) === 3) &&
      !benefitList.some((item) => item?.rider === "PWB1-PWB3")
    ) {
      benefitList.push({
        label:
          "Achieves your family goals even if you're not there to pay the premiums",
        rider: "PWB1-PWB3",
      });
      benefitList = benefitList.filter((item) => item?.rider !== "PWB2");
    }

    if (
      Number(biData.bi_request?.PWB) === 2 &&
      !benefitList.some((item) => item?.rider === "PWB2")
    ) {
      benefitList.push({
        label:
          "Achieves your family goals even if you're able to pay the premiums due to unforseen circumstances",
        rider: "PWB2",
      });
      benefitList = benefitList.filter((item) => item?.rider !== "PWB1-PWB3");
    }
  } else {
    benefitList = benefitList.filter(
      (item) => item?.rider !== "PWB1-PWB3" || item?.rider !== "PWB2"
    );
  }

  return benefitList;
};

export default fetchProductLevelRidersBenefit;
